import { render, staticRenderFns } from "./GroupNotesDialog.vue?vue&type=template&id=63d53db0&scoped=true"
import script from "./GroupNotesDialog.ts?vue&type=script&lang=ts&external"
export * from "./GroupNotesDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupNotesDialog.scss?vue&type=style&index=0&id=63d53db0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d53db0",
  null
  
)

export default component.exports